module.exports = "<div ng-if=\"error\" class=\"u-error saveCard-error\">{{error}}</div>\r\n\r\n<button class=\"button saveCard-saveButton\" ng-click=\"saveCard()\" ng-if=\"!cardSaved\">Save my card for future purchases</button>\r\n<button class=\"button saveCard-saveButton\" ng-if=\"cardSaved\" disabled>Card saved successfully <i class=\"icon-tick\"></i></button>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/savedcard/save-card-template.html
 ** module id = 986
 ** module chunks = 1
 **/